import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PortalPage from "../pages/portal/page";
import ContactPage from "../pages/contact/page";
import SpecialistsPage from "../pages/specialists/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/inteligencia-imobiliaria",
    element: <PortalPage />,
  },
  { path: "/o-sebraci", element: <PortalPage /> },
  { path: "/nossa-arquitetura", element: <Navigate to="/o-sebraci" replace /> },
  { path: "/solucoes", element: <PortalPage /> },
  { path: "/consultoria-e-gestao", element: <PortalPage /> },
  { path: "/educacao", element: <PortalPage /> },
  { path: "/tecnologia", element: <PortalPage /> },
  { path: "/comunidade", element: <PortalPage /> },
  { path: "/cases", element: <Navigate to="/o-sebraci" replace /> },
  { path: "/especialistas", element: <SpecialistsPage /> },
  { path: "/contato", element: <ContactPage /> },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
